// Site Configurations for Sofitel Boutique
// -- These values are unique for each site and rarely need to be changed after initial setup
// -- They are passed to the coreContext in _app.tsx and can be accessed in hah-fe-core via the useContext hook

import { UtilityIcons } from '@Hotels-at-Home/hah-fe-core/dist/types';

export const csrEmail = 'customer.service@sofitelboutique.com';
export const siteName = 'Sofitel Boutique';
export const parentHotelCompany = 'Accor'; // "Accor" or "Marriott"
export const hotelBrandName = 'Sofitel';
export const catalogId = 'SOF';
export const region = 'EU';
export const employeePromoTag = 'accorhotels-bienvenue';

export const scandiWebMenuId = 'sof';
export const companyTelephone = '+33 1 41515151';

export const LOGO_IMAGE = { src: '/images/misc/sofitel-boutique-logo.svg', alt: '' };

export const promo = {
  displaySaleFlag: false,
  // Promo discount (in percent)
  discount: '-35%',
  // products "SKUs" excluded from sale (the SaleFlag will be not displayed for this items)
  productsSaleExcludeList: [] as string[],
  // categories "IDs" excluded from sale (the SaleFlag will be not displayed for this items)
  categoriesSaleExludeList: [] as number[],
};

export const accorTagging = {
  accorTaggingEnabled: true,
  pageNamePrefix: 'sofitel',
};
// Product/Category Page Settings
// - imageWidth/imageHeight set the size of the <img /> on cat/prod pages to prevent layout shift
export const product = {
  imageWidth: 1000,
  imageHeight: 1022,
  imageWidthThumbnail: 500,
  ctaBlackUpsellLink: true,
  counterButtons: true,
  alignCounterWithCartBtn: true,
  outsideLabels: false,
  itemCopyDesktop: 'accordion',
  verticalCarousel: true,
  breadCrumbPosition: 'product-config',
  enableAccorRewardsTab: true,
  almaBanner: true,
  addonModalSize: 'sm',
  stickConfigBlock: true,
};

export const category = {
  imageEagerLoadingAmount: 3,
  colorSwitcher: true,
  disableColorSwitcherImageSwitching: true,
  displayPrices: true,
  colorSwitcherMode: 'hover', // 'default' | 'click' | 'hover'
  seoImageWidth: 1440,
  seoImageHeight: 620,
  maxSwatches: 25,
};

export const checkout = {
  radioButtons: true,
  placeholderLabels: true,
  aboveTotalsCouponCode: true,
  showEditButton: true,
  paymentMethodProceedButton: true,
};

export const header = {
  mobileNavLogo: true,
  mobileNavHome: true,
  leftDrawerUtilities: true,
  iconOrder: [
    UtilityIcons.Language,
    UtilityIcons.Currency,
    UtilityIcons.Search,
    UtilityIcons.ShoppingCart,
    UtilityIcons.Account,
  ],
};

export const notFoundPage = {
  button: true,
};

export const search = { wishlistButton: true };

// Misc
export const firstVisitModal = {
  modalWidth: 600,
};

// Adobe Launch Settings
// - Remove these lines completely if this is not a Marriott site
export const enableBonvoyNumber = false;
export const enableAccorAllNumber = true;
export const enableMarriottAdobeLaunch = false;
// export const marriottAdobeLaunchBrandCode = 'MC';
// export const marriottAdobeLaunchBrandName = 'Marriott Hotels & Resorts';

// Google Tag Manager & Analytics Settings
export const enableGoogleTagManager = true;
export const googleTagManagerId = 'GTM-WXXN9TM';
export const productNameFilters = {
  replacements: [{ target: 'Shop Sofitel Boutique', replacement: 'Shop' }],
  splits: [{ split: ' - ', keepIndex: 0 }],
};

// Cookie Restorer for Safari ITP
export const cookieRestorerEnabled = true;
export const cookieRestorerOptions = { options: { interval: 5000 } };

// Meta Tags
// export const googleSiteVerification = '';
export const defaultOgImage = '/images/homePage/heroSection/hp-mybed-mob.jpg';

export const INTL_SITES = [
  {
    region: 'NA',
    links: [
      { value: 'English', url: 'https://na.sofitelboutique.com/?referrer=eu', icon: 'us' },
      { value: 'Français', url: 'https://na.sofitelboutique.com/fr?referrer=eu', icon: 'ca' },
    ],
  },
  {
    region: 'APAC',
    links: [
      { value: 'English', url: 'https://www.shopsofitel.cn/en/?___store=soficn_en' },
      { value: '简体中文', url: 'https://www.shopsofitel.cn/zh-CN/?___store=soficn_en' },
    ],
  },
];

export const account = {
  accountGlobalEnable: true,
  emptyWishlistYmals: true,
  wishlistImageWidth: 424,
  wishlistImageHeight: 434,
  disableAccountDrawer: true,
  enableLogoutBtn: true,
  enableWelcomeMessage: true,
  register: {
    hahSubscribeCheckbox: true,
  },
};

export const cart = {
  counterButtons: true,
  useCartDrawer: true,
  staticQuantity: true,
  ymalName: 'SOF - Cart',
};

// if the route includes the name of one object, we use this data to build page_view and userInteract events for the dataLayer
// needed for posts landing page
export const overrideDataLayerRoutes = [
  {
    name: '/posts/about-us',
    pageName: 'hub_articles',
    pageCategory: 'store',
    pageType: 'hub_articles',
    pageVirtualPath: '/hub_carticles/',
  },
  {
    name: '/posts/qui-sommes-nous',
    pageName: 'hub_articles',
    pageCategory: 'store',
    pageType: 'hub_articles',
    pageVirtualPath: '/hub_carticles/',
  },
  {
    name: '/posts/uber-uns',
    pageName: 'hub_articles',
    pageCategory: 'store',
    pageType: 'hub_articles',
    pageVirtualPath: '/hub_carticles/',
  },
  {
    name: '/posts/quienes-somos',
    pageName: 'hub_articles',
    pageCategory: 'store',
    pageType: 'hub_articles',
    pageVirtualPath: '/hub_carticles/',
  },
];

export const noZeroAfterDecimal = true;
